/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HorseRegisterDto
 */
export interface HorseRegisterDto {
    /**
     * 
     * @type {string}
     * @memberof HorseRegisterDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HorseRegisterDto
     */
    breed?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof HorseRegisterDto
     */
    birthday?: Date;
    /**
     * 
     * @type {string}
     * @memberof HorseRegisterDto
     */
    color?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HorseRegisterDto
     */
    gender?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HorseRegisterDto
     */
    owner?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HorseRegisterDto
     */
    mother?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HorseRegisterDto
     */
    father?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof HorseRegisterDto
     */
    registerDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof HorseRegisterDto
     */
    bookerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HorseRegisterDto
     */
    bookerEmail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HorseRegisterDto
     */
    remark?: string | null;
    /**
     * Stockma� in cm
     * @type {number}
     * @memberof HorseRegisterDto
     */
    stockSize?: number | null;
    /**
     * Lebensnummer
     * @type {string}
     * @memberof HorseRegisterDto
     */
    lifeNumber?: string | null;
}

/**
 * Check if a given object implements the HorseRegisterDto interface.
 */
export function instanceOfHorseRegisterDto(value: object): value is HorseRegisterDto {
    return true;
}

export function HorseRegisterDtoFromJSON(json: any): HorseRegisterDto {
    return HorseRegisterDtoFromJSONTyped(json, false);
}

export function HorseRegisterDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): HorseRegisterDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'breed': json['breed'] == null ? undefined : json['breed'],
        'birthday': json['birthday'] == null ? undefined : (new Date(json['birthday'])),
        'color': json['color'] == null ? undefined : json['color'],
        'gender': json['gender'] == null ? undefined : json['gender'],
        'owner': json['owner'] == null ? undefined : json['owner'],
        'mother': json['mother'] == null ? undefined : json['mother'],
        'father': json['father'] == null ? undefined : json['father'],
        'registerDate': json['registerDate'] == null ? undefined : (new Date(json['registerDate'])),
        'bookerId': json['bookerId'] == null ? undefined : json['bookerId'],
        'bookerEmail': json['bookerEmail'] == null ? undefined : json['bookerEmail'],
        'remark': json['remark'] == null ? undefined : json['remark'],
        'stockSize': json['stockSize'] == null ? undefined : json['stockSize'],
        'lifeNumber': json['lifeNumber'] == null ? undefined : json['lifeNumber'],
    };
}

export function HorseRegisterDtoToJSON(json: any): HorseRegisterDto {
    return HorseRegisterDtoToJSONTyped(json, false);
}

export function HorseRegisterDtoToJSONTyped(value?: HorseRegisterDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'breed': value['breed'],
        'birthday': value['birthday'] == null ? undefined : ((value['birthday']).toISOString().substring(0,10)),
        'color': value['color'],
        'gender': value['gender'],
        'owner': value['owner'],
        'mother': value['mother'],
        'father': value['father'],
        'registerDate': value['registerDate'] == null ? undefined : ((value['registerDate']).toISOString()),
        'bookerId': value['bookerId'],
        'bookerEmail': value['bookerEmail'],
        'remark': value['remark'],
        'stockSize': value['stockSize'],
        'lifeNumber': value['lifeNumber'],
    };
}

